import {
  TaxTraxTaxBillRecordState,
  TaxTraxTaxDetailsActionTypes,
  TAXTRAX_TAX_BILL_RECORD_ADD,
  TAXTRAX_TAX_BILL_RECORD_CLEAR,
  TAXTRAX_TAX_BILL_RECORD_LOADING,
} from './TaxTraxTaxBillRecord.types';

const defaultState: TaxTraxTaxBillRecordState = {
  taxBillRecord: null,
  taxBill: null,
  loading: false,
};

export function taxTraxTaxBillRecordReducer(
  state = defaultState,
  action: TaxTraxTaxDetailsActionTypes,
): TaxTraxTaxBillRecordState {
  switch (action.type) {
    case TAXTRAX_TAX_BILL_RECORD_CLEAR: {
      return {
        ...defaultState,
      };
    }
    case TAXTRAX_TAX_BILL_RECORD_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case TAXTRAX_TAX_BILL_RECORD_ADD: {
      return {
        ...state,
        taxBillRecord: action.payload.taxBillRecord,
        taxBill: action.payload.taxBill,
      };
    }
    default:
      return state;
  }
}
